import { defineWidget } from '../widget-types';

export const containerFrameWidget = defineWidget({
  type: 'container-frame',
  schema: {
    label: 'Container Frame',
    description: 'Visual container with configurable layout direction, gap, alignment, and padding',
    props: {
      direction: {
        type: 'enum',
        label: 'Direction',
        options: ['row', 'column'],
        default: 'column',
      },
      gap: {
        type: 'enum',
        label: 'Gap',
        options: ['none', 'sm', 'md', 'lg', 'xl'],
        default: 'md',
      },
      alignItems: {
        type: 'enum',
        label: 'Align Items',
        options: ['start', 'center', 'end', 'stretch'],
        default: 'stretch',
      },
      justifyContent: {
        type: 'enum',
        label: 'Justify Content',
        options: ['start', 'center', 'end', 'between', 'around', 'evenly'],
        default: 'start',
      },
      wrap: {
        type: 'boolean',
        label: 'Wrap',
        default: false,
      },
      width: {
        type: 'enum',
        label: 'Width',
        options: ['auto', 'full', 'fit'],
        default: 'full',
      },
      minHeight: {
        type: 'enum',
        label: 'Min Height',
        options: ['none', 'screen', '200', '400', '600'],
        default: 'none',
      },
      padding: {
        type: 'enum',
        label: 'Padding',
        options: ['none', 'sm', 'md', 'lg', 'xl'],
        default: 'none',
      },
      /* Framer-style stack controls (plan: lego step 1). Optional; when set they win over the presets
       * above. Rendered through stackStyle() (utils/stack-style.ts) by the store AND the editor. */
      gapPx: { type: 'number', label: 'Gap (px)', min: 0, max: 400 },
      paddingPx: { type: 'number', label: 'Padding (px)', min: 0, max: 400 },
      paddingXPx: { type: 'number', label: 'Padding left/right (px)', min: 0, max: 400 },
      paddingYPx: { type: 'number', label: 'Padding top/bottom (px)', min: 0, max: 400 },
      widthMode: { type: 'enum', label: 'Width', options: ['fill', 'hug', 'fixed'] },
      widthPx: { type: 'number', label: 'Width (px)', min: 0, max: 4000 },
      heightMode: { type: 'enum', label: 'Height', options: ['fill', 'hug', 'fixed'] },
      heightPx: { type: 'number', label: 'Height (px)', min: 0, max: 4000 },
      background: { type: 'color', label: 'Background' },
      radius: { type: 'number', label: 'Corner radius (px)', min: 0, max: 400 },
      borderWidth: { type: 'number', label: 'Border (px)', min: 0, max: 40 },
      borderColor: { type: 'color', label: 'Border colour' },
    },
    dataDeps: [],
  },
  nameTh: 'กรอบคอนเทนเนอร์',
  descriptionTh: 'กรอบที่มองเห็นพร้อมพื้นหลังและขอบ',
  category: 'layout',
  thumbnail: '/widget-thumbnails/container-frame.svg',
  defaults: {
    type: 'container-frame',
    props: { direction: 'column', gap: 'md', padding: 'md' },
  },
});
